import React from 'react';

interface WrapperProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
}

const HomeWrapper: React.FC<WrapperProps> = ({
  children,
  className,
  ...rest
}) => {
  return (
    <div className={`${className}`} {...rest}>
      <div className={`container mx-auto py-12 md:py-20`}>{children}</div>
    </div>
  );
};

export default HomeWrapper;
